interface FormData {
  login_id?: string;
  password?: string;
}

interface FormErrors {
  login_id?: string;
  password?: string;
}

export const loginFormValidator = (formData: FormData): FormErrors => {
  let errors: FormErrors = {};

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^(17|16|77)[0-9]{6}$/;

  // Validate login_id
  if (!formData.login_id || !formData.login_id.trim()) {
    errors.login_id = "Email or mobile number is required";
  } else if (
    !emailRegex.test(formData.login_id.trim()) &&
    !phoneRegex.test(formData.login_id.trim())
  ) {
    errors.login_id = "Enter a valid email or phone number";
  }

  // Validate password
  if (!formData.password || !formData.password.trim()) {
    errors.password = "Password is required";
  } else if (formData.password.length < 4) {
    errors.password = "Password must be at least 8 characters long";
  } 

  return errors;
};
